import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../../styles";

interface Props {
  subEtapaFunil: string;
}

export const SubetapaCell: React.FC<Props> = ({ subEtapaFunil }) => (
  <Styles.Td>
    <Tooltip
      followCursor
      title={subEtapaFunil || "--"}
      placement="top-start"
      arrow
    >
      <p>{subEtapaFunil || "--"}</p>
    </Tooltip>
  </Styles.Td>
);
